
      import * as buffer from 'buffer';
      if (typeof window.Buffer === 'undefined') {
        window.Buffer = buffer.Buffer;
      }
    